import { Component, Inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { IdleDialogActionType } from '../../models';

@Component({
  selector: 'app-idle-dialog',
  templateUrl: './idle-dialog.component.html',
  styleUrl: './idle-dialog.component.scss',
  standalone: false,
})
export class IdleDialogComponent {
  timer: Signal<number | undefined> = toSignal(this.data);

  constructor(
    private readonly dialogRef: MatDialogRef<IdleDialogComponent, IdleDialogActionType>,
    @Inject(MAT_DIALOG_DATA) public readonly data: Observable<number>,
  ) {}

  onLogout() {
    this.dialogRef.close(IdleDialogActionType.Logout);
  }

  onContinue() {
    this.dialogRef.close(IdleDialogActionType.Continue);
  }
}
